module.exports = __webpack_public_path__ + "img/4.d08b303f.jpg";